<ion-app>
	<app-burger-menu></app-burger-menu>
	<!-- todo: put this content only on desired pages -->
	<ion-router-outlet id="menuContent"></ion-router-outlet>
	<app-loading-indicator></app-loading-indicator>
	<ion-toast></ion-toast>
</ion-app>
